import { Component } from 'react';
import React from 'react';
import {NavLink} from 'react-router-dom';
class EmptyReports extends Component {
    _renderEmpty(value, key) {
        return (

            <li>
                <a target="_BLANK" href="#open">
                    <div className="list__item list__item--col-4 list__item--smaller">Geen verzamelberichten beschikbaar</div>
                </a>
            </li>
        )
    }
    
    render () {
        return (

                <div className="card">
                 
                    <div className="card__header">
                        <h1>Verzamelberichten</h1>
                        <NavLink to={"/reports" } className="top__right__link">
                                Nieuw verzamelbericht opvragen
                        </NavLink>
                    </div>

                    <div className="card__body">
                        <div className="card__content">
                            <ul className="styled__list__headers">
                                <li className="list__header list__header--col-2">Soort verzamelbericht</li>
                                <li className="list__header list__header--col-2">Herhaling</li>
                                <li className="list__header list__header--col-2">Datum aangevraagd</li>
                                <li className="list__header list__header--col-2">Houdbaarheid</li>
                                <li className="list__header list__header--col-2">Nieuw verzamelbericht</li>
                                <li className="list__header list__header--col-2--last">Actief?</li>
                            </ul>
                            <ul className="styled__list">
                                {this._renderEmpty()}
                            </ul>
                        </div>
                    </div>
                </div>
            )
    }
}



export default EmptyReports;



// WEBPACK FOOTER //
// ./src/components/Addresses/EmptyReports/index.js